var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRemoveS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.121 1.464A1 1 0 0 1 8.536 2.88L6.414 5l2.122 2.121A1 1 0 0 1 7.12 8.536L5 6.414 2.879 8.536A1 1 0 0 1 1.464 7.12L3.586 5 1.464 2.879A1 1 0 0 1 2.88 1.464L5 3.586z"
})));
export default SvgIconRemoveS;